import "../../style/mobile/store/MS_Products.scss";
import { useSelector } from "react-redux";
import icon1 from "../../../assets/mobile/home/vuesax-linear-calendar.svg";
import icon2 from "../../../assets/mobile/home/vuesax-linear-profile-2user.svg";
import icon3 from "../../../assets/mobile/home/vuesax-linear-teacher.svg";
import { useState } from "react";
import { Link } from "react-router-dom";
import moment from "jalali-moment";

const MS_Products = () => {
  const state = useSelector((state) => state.default);
  const [data] = useState(state.ExamData);

  moment.locale("en");
  return (
    <div className="MS_Products">
      {data.map((item, index) => (
        <div className="MS_Products-item">
          <div className="MS_Products-item-img-container">
            <img src={item.img} alt="item-img" />
            <Link to={`/dashboard/store/${item.id}`} className="MS_Products-item-img-container-cover"></Link>
          </div>
          <div className="MS_Products-item-title">{item.name}</div>
          <div className="MS_Products-item-price-box">
            <div
              style={
                item.badge
                  ? { textDecoration: "line-through", color: "#A7A5A5" }
                  : {
                      width: "100%",
                      justifyContent: "center",
                    }
              }
              className="MS_Products-item-price-box-main-price"
            >
              {item.masterPrice}
              <span>تومان</span>
            </div>
            {item.badge && (
              <div className="MS_Products-item-price-box-discounted-price">
                {item.price}
                <span>تومان</span>
              </div>
            )}
            {item.badge && (
              <div className="MS_Products-item-price-box-discount">
                {item.badge}
              </div>
            )}
          </div>
          <div className="MS_Products-item-info">
            <div className="MS_Products-item-info-date">
              <img
                src={icon1}
                alt="date-icon1"
                className="MS_Products-item-info-date-icon"
              />
              <div className="MS_Products-item-info-date-text">
                {moment(item.date, 'YYYY/MM/DD').format('jYYYY/jM/jD')}
              </div>
            </div>
            <div className="MS_Products-item-info-level">
              <img
                src={icon3}
                alt="date-icon1"
                className="MS_Products-item-info-level-icon"
              />
              <div className="MS_Products-item-info-level-text">
                {item.level}
              </div>
            </div>
            <div className="MS_Products-item-info-type">
              <img
                src={icon2}
                alt="date-icon1"
                className="MS_Products-item-info-type-icon"
              />
              <div className="MS_Products-item-info-type-text">
                {item.type===1 && "انفرادی"}
                {item.type===2 && "گروهی"}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MS_Products;
